import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Base_ResolutionFunctionEditorPanel } from '../Base_ResolutionFunctionEditorPanel.js';
import './Panel_EditDesctiption.scss';
import { Component_ExpressionDescription } from '@app/hcs-frontend/expression';
export class Panel_EditDescription extends Base_ResolutionFunctionEditorPanel {
    panelId = 'edit-description';
    shouldReDeriveState(nextProps) {
        if (this.state.tag !== nextProps.editableExpression.tag)
            return true;
        return super.shouldReDeriveState(nextProps);
    }
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (this.state.tag !== nextState.editableExpression.tag)
            return true;
        return super.shouldComponentUpdate(nextProps, nextState, nextContext);
    }
    deriveStateFromProps(nextProps, state) {
        state.editableExpression = nextProps.editableExpression;
        state.tag = state.editableExpression.tag;
        return state;
    }
    renderHeader = () => {
        return _jsx(_Fragment, { children: "Enter Resolution function Description" });
    };
    renderBody = () => {
        return _jsx(Component_ExpressionDescription, { editable: this.state.editableExpression });
    };
}
//# sourceMappingURL=Panel_EditDescription.js.map